import React, { useEffect, useState } from 'react';
import { JBAlert } from '@jbhi-fi/lanyard-ui';
import ReceiptLayout from '../receipt.layout';
import PreviewComponent from '../components/preview.component';
import IllustrationComponent from '../components/illustration.component';
import DownloadComponent from '../components/download.component';
import { formatDateTime12hrsPrintMonth } from '../../../../utils/date-time';
import { useReceiptContext } from '../context/receipt.context';
import { useLoginTracking } from '../../../../hooks/useLoginTracking/useLoginTracking';
import { UnverifiedReceiptLanding } from '../components/UnverifiedReceipt/UnverifiedReceiptLanding';
import { useTrackingContext } from '@jbhi-fi/components/src/Tracking';

const LandingView = ({ receiptId, history }) => {
  const { isLoading, data, isLinked } = useReceiptContext();
  const [downloadError, setDownloadError] = useState(null);
  const customerEmail = window.Jbhifi?.customerEmail;
  const storeName = data.receipt?.ReceiptData?.LocationDescription;
  const isPerksDisabled = window.Jbhifi?.isPerksDisabled;
  const dateTime =
    data.receipt?.ReceiptData && formatDateTime12hrsPrintMonth(new Date(data.receipt?.ReceiptData?.SaleDateTime));
  const receiptStatus = data.receipt?.ItemLinked ? 'claimed' : 'unclaimed';
  const params = new URLSearchParams(`source=DRNew&storeId=${data?.receipt?.ReceiptData?.LocationNo}`);
  const { tracker } = useTrackingContext();
  useLoginTracking({
    baseEventData: { eventCategory: tracker.category, data: { claimed: receiptStatus } },
  });
  const preventAutoDownload = window.location.href.includes('autoDownload=false');

  useEffect(() => {
    if (receiptId && receiptId === data?.receipt?.ReceiptData?.Code) {
      if (data.verify?.raw?.data?.phone || isLinked) {
        history.push(`/${receiptId}/already-claimed${preventAutoDownload ? '?autoDownload=false' : ''}`);
      } else if (data.verify?.isTooManyAttempts) {
        history.push(`/lockedout`);
      } else if (
        data.receipt.ErrorCode &&
        (data.receipt.ErrorCode === 'InvalidReceiptCode' || data.receipt.ErrorCode === 'InvalidData')
      ) {
        history.push(`/`);
      }
    }
  }, [data]);

  return (
    <ReceiptLayout ripped wide isLoading={isLoading}>
      {downloadError ? (
        <JBAlert
          showIcon
          type="error"
          heading={"Can't download receipt"}
          content="We were unable to download your receipt, please contact customer service."
        />
      ) : null}
      <div
        className={`primary-block ${
          isPerksDisabled ? '' : 'primary-block-perks'
        } receipt-details ribbon ribbon--top ribbon--flip`}
      >
        {isPerksDisabled ? null : <IllustrationComponent name="claimed" />}
        <div className={isPerksDisabled ? '' : 'primary-block-preview'}>
          <PreviewComponent
            isPerksDisabled={isPerksDisabled}
            storeName={storeName}
            dateTime={dateTime}
            receiptId={receiptId}
            receiptToken={data.receipt?.ReceiptToken}
            history={history}
            setError={setDownloadError}
          />
        </div>
      </div>
      {!isLinked && !data.verify?.raw?.data?.phone && !data?.verify?.isTooManyAttempts ? (
        <>
          {isPerksDisabled ? (
            <UnverifiedReceiptLanding
              customerEmail={customerEmail}
              receiptId={receiptId}
              phoneNumber={
                data?.verify?.raw?.data?.phone ??
                (data?.receipt?.MobileNumber || data?.receipt?.ReceiptData?.MobileNumber)
              }
              params={params}
            />
          ) : (
            <>
              <div className="ribbon ribbon--no-shadow ribbon--side-borders" />
              <DownloadComponent
                receiptId={receiptId}
                receiptToken={data.receipt?.ReceiptToken}
                history={history}
                setError={setDownloadError}
                preventAutoDownload={preventAutoDownload}
              />
            </>
          )}
        </>
      ) : null}
    </ReceiptLayout>
  );
};

export default LandingView;
